module.exports = __webpack_public_path__ + "2cc3c133cdf9c5b767bdfbf16ef18feb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Roboto-Regular-webfont.svg
// module id = 74
// module chunks = 0